import { type DocumentAttachment } from "@overmap-ai/common"
import { selectDocumentAttachmentById } from "@overmap-ai/core"
import type { NodeViewProps } from "@tiptap/react"
import { memo } from "react"

import { sdk } from "../../../sdk"
import { useAppSelector } from "../../../store"
import { BaseAttachmentNodeComponent } from "../BaseAttachment/Component"
import { NotFoundAttachmentNode } from "../BaseAttachment/FallbackAttachmentNode"

export const DocumentAttachmentNodeComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const attachmentId = node.attrs.uuid as string
	const documentAttachment = useAppSelector(selectDocumentAttachmentById(attachmentId))

	if (!documentAttachment) {
		return <NotFoundAttachmentNode {...props} />
	}

	return (
		<BaseAttachmentNodeComponent<DocumentAttachment>
			attachment={documentAttachment}
			service={sdk.documentAttachments}
			{...props}
		/>
	)
})
DocumentAttachmentNodeComponent.displayName = "DocumentAttachmentNodeComponent"
